import styled from 'styled-components'

export const MainContainer = styled.div`
  width: 100%;
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10vh 7vh 9.5vh 10.2vh;
  margin-left: -10px;
  width: fit-content;

  background-color: var(--aliceBlueLight);
  border-radius: 20px;

  transition: all 0.3s;

  @media (max-width: 1050px) {
    margin-left: 0px;
    margin-bottom: 10px;
    padding: 9vh 15px 0vh 15px;
    width: 100%;
  }

  @media (min-width: 1700px) {
    margin-left: -20px;
  }

  &.toFront {
    position: relative;
    z-index: 1;
    -webkit-box-shadow: 30px 20px 99px 0px var(--shadowPrimary);
    -moz-box-shadow: 30px 20px 99px 0px var(--shadowPrimary);
    box-shadow: 30px 20px 99px 0px var(--shadowPrimary);
  }
`

export const TextTop = styled.div`
  padding-bottom: 67.97px;

  @media (max-width: 1050px) {
    padding-bottom: 30px;
  }

  h2 {
    font-size: 33px;
    color: var(--text);

    @media (max-width: 1050px) {
      font-size: 23px;
      text-align: center;
    }
  }
`

export const Form = styled.form`
  position: relative;
`

export const ForgetPassword = styled.span`
  position: absolute;
  right: 21.9px;
  top: 25px;

  font-family: 'Poppins', sans-serif;
  font-size: 10px;
  text-decoration: none;

  color: #707070;
  opacity: 0.4;

  transition: 0.3s;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }
`

export const PopoverContainer = styled.div`
  position: absolute;
  z-index: 2;
  top: 36px;
  right: 0px;
  width: 192px;
`

export const BtnContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 5vh;
  padding-bottom: 46px;
  width: 352px;

  @media (max-width: 1050px) {
    width: 100%;
  }
`
